import { FC } from 'react';
import Stack from '../Stack/Stack';
import Text from '../Text/Text';
import './DataView.css';
import Menu from '../Menu/Menu';
import MenuItem from '../MenuItem/MenuItem';
import Popover from '../Popover/Popover';
import { useAppContext } from '@/context/AppContext';
import Button from '../Button/Button';

interface DataViewProps {
  data: any[];
  onSelect?: (item: any) => void;
  selectedId?: string;
  renderChildren?: boolean;
}

const DataView: FC<DataViewProps> = ({ data, onSelect, selectedId, renderChildren = false }) => {
  const { deleteItem, deleteChildItem } = useAppContext();

  if (!data || data.length === 0) {
    return (
      <Stack className="data-view data-view--empty">
        <Text>Nothing to show here...</Text>
      </Stack>
    );
  }

  const handleDeleteItem = (item: any, event: React.MouseEvent) => {
    event.stopPropagation();
    deleteItem(item.id);
  };

  const handleDeleteChildItem = (item: any, event: React.MouseEvent) => {
    event.stopPropagation();
    
    // Handle different child item types
    if (item.type === 'linkAction') {
      deleteChildItem(item.linkId, 'linkAction', item.actionIndex);
    }
    // Add more child item type handling here in the future
  };

  const renderItem = (item: any, isChild = false) => {
    return (
      <MenuItem
        key={item.id}
        onClick={() => onSelect?.(item)}
        isSelected={selectedId === item.id}
        icon={item.icon || "Box"}
        className={isChild ? "data-view__child-item" : ""}
      >
        <Stack direction="horizontal" justify="between" align="center" fill>
          <Stack direction="horizontal" gap="md" className={isChild ? "data-view__child-content" : ""} fill>
            <Text>{item.name}</Text>
          </Stack>
          <Popover
            content={
              <Menu>
                <MenuItem 
                  onClick={(e) => isChild ? handleDeleteChildItem(item, e) : handleDeleteItem(item, e)} 
                  icon="Trash"
                >
                  <Text>Delete</Text>
                </MenuItem>
              </Menu>
            }
            trigger="click"
            placement="bottom-end"
            stopPropagation={true}
          >
            <Button className="data-view__menu-button">•••</Button>
          </Popover>
        </Stack>
      </MenuItem>
    );
  };

  return (
    <Menu className="data-view">
      {data.map((item) => {
        const hasChildren = renderChildren && item.children && item.children.length > 0;
        
        return (
          <div key={item.id} className="data-view__item">
            {renderItem(item)}
            {hasChildren && (
              <div className="data-view__children">
                {item.children.map((child: any) => renderItem(child, true))}
              </div>
            )}
          </div>
        );
      })}
    </Menu>
  );
};

export default DataView; 
